/* ============
 * Application State
 * ============
 *
 * The state of the application module.
 */

export default {
  snackbar: {
    message: undefined,
    action: {
      text: undefined,
      handler: undefined,
    },
    active: undefined,
  },
  loading: undefined,
};




// WEBPACK FOOTER //
// ./src/store/modules/application/state.js